<template>
	<svg :width="props.width" :height="props.height" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path
			fill-rule="evenodd"
			clip-rule="evenodd"
			d="M11 4.79995C7.57579 4.79995 4.79995 7.57579 4.79995 11C4.79995 14.4241 7.57579 17.2 11 17.2C14.4241 17.2 17.2 14.4241 17.2 11C17.2 7.57579 14.4241 4.79995 11 4.79995ZM3.19995 11C3.19995 6.69213 6.69213 3.19995 11 3.19995C15.3078 3.19995 18.8 6.69213 18.8 11C18.8 15.3078 15.3078 18.8 11 18.8C6.69213 18.8 3.19995 15.3078 3.19995 11Z"
			:fill="props.iconColor"
		/>
		<path
			fill-rule="evenodd"
			clip-rule="evenodd"
			d="M15.4343 15.4343C15.7467 15.1218 16.2532 15.1218 16.5656 15.4343L20.5656 19.4343C20.8781 19.7467 20.8781 20.2532 20.5656 20.5656C20.2532 20.8781 19.7467 20.8781 19.4343 20.5656L15.4343 16.5656C15.1218 16.2532 15.1218 15.7467 15.4343 15.4343Z"
			:fill="props.iconColor"
		/>
	</svg>
</template>
<script setup lang="ts">
const props = withDefaults(
	defineProps<{
		width?: string | number;
		height?: string | number;
		iconColor?: string;
	}>(),
	{
		width: 24,
		height: 24,
		iconColor: '#ffffff',
	}
);
</script>

<style lang="scss" scoped></style>
